/**
 *
 * Details Service Actions
 *
 */

import {
  DETAILS_REQUEST,
  NOT_ASKED,
  LOADING,
  SUCCESS,
  FAILURE,
  UPDATE_CURRENT_TRANSFER,
} from './constants';

/**
 * Kicks off the saga that initiates the request.
 *
 * withRecentDeposits :bool: If true, upon success, we kick off a
 * searchRequest for the apexAccountNumber in the recentDeposits service.
 */
export function detailsRequest(transferId, withRecentDeposits=false) {
  return {
    type: DETAILS_REQUEST,
    transferId,
    withRecentDeposits,
  };
}

/**
 * Used by the saga to set the status.
 */
export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

/**
 * Used by the saga to set the status and store params.
 */
export function loading(transferId) {
  return {
    type: LOADING,
    transferId,
  };
}

/**
 * Used by the saga to set the status and store result.
 */
export function success(result) {
  return {
    type: SUCCESS,
    result,
  };
}

/**
 * Used by the saga to set the status and store the error.
 */
export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}

/**
 * Used by other services to update data about a transfer that has been modified by some PUT/POST/PATCH request.
 * At the time this was written the only such service that does this is the actions service.
 *
 * The api does not return the whole transfer, so we need to interpolate the responses from other services with this one.
 */

export function updateCurrentTransfer(newData) {
  return {
    type: UPDATE_CURRENT_TRANSFER,
    newData,
  };
}



// WEBPACK FOOTER //
// ./src/services/details/actions.js